import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Speakers() {
  useDocumentTitle("Prelegentki", "10 kobiet, 10 perspektyw. Poznaj prelegentki mamy!kongres 2027.");
  return (
    <div>
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-8 pb-14">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E6007A] mb-6">Prelegentki 2027</div>
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] mb-8">
          10 kobiet, <br />10 <span className="italic text-[#E6007A]">perspektyw</span>.
        </h1>
        <p className="text-xl text-[#5C534D] leading-relaxed max-w-3xl mb-10">
          Dobieramy je tak, żebyś z każdego warsztatu wyniosła coś dla siebie — bez względu na to,
          czy już jesteś mamą, czy dopiero planujesz nią być.
        </p>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-tight text-[#2B2623]">
          Na dobry skład warto chwilę poczekać...
        </h2>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
      </section>
    </div>
  );
}
